import React, { useEffect, useState } from 'react'

import { Card, Table, Tag, Button, Spin, Empty, message } from 'antd'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { operatorApiFetch } from '@services/operator/apiService'

import { formatDateTime } from '@/utils/dateTime'

const ResidualTotes = () => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(true)
  const [rows, setRows] = useState([])

  const fetchData = async () => {
    setLoading(true)
    try {
      // operatorApiFetch 已對非 2xx（除 422）throw，無須再檢查 res.ok。
      const res = await operatorApiFetch('picking_lists/residual_totes')
      const json = await res.json()
      setRows(json.data || [])
    } catch (e) {
      console.error('[ResidualTotes] fetch failed:', e)
      message.error(t('common.error.operation_failed'))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const statusColor = (status) => {
    if (status === 'done') return 'green'
    if (status === 'terminated') return 'volcano'
    return 'default'
  }

  const columns = [
    {
      title: t('shared.picking_lists.residual_totes.columns.name'),
      dataIndex: 'display_name',
      key: 'name',
      render: (name, record) => <Link to={`/picking_lists/${record.id}`}>{name}</Link>,
    },
    {
      title: t('shared.picking_lists.residual_totes.columns.wave'),
      dataIndex: 'wave_name',
      key: 'wave',
    },
    {
      title: t('shared.picking_lists.residual_totes.columns.status'),
      dataIndex: 'status',
      key: 'status',
      render: (s) => (
        <Tag color={statusColor(s)}>{t(`enums.picking_list.status.${s}`)}</Tag>
      ),
    },
    {
      title: t('shared.picking_lists.residual_totes.columns.last_updated_at'),
      dataIndex: 'last_updated_at',
      key: 'last_updated_at',
      render: (v) => (v ? formatDateTime(v) : '-'),
    },
    {
      title: t('shared.picking_lists.residual_totes.columns.tote_location'),
      dataIndex: 'tote_location',
      key: 'tote_location',
      render: (v) => (v ? <Tag color="blue">{v}</Tag> : '-'),
    },
    {
      title: t('shared.picking_lists.residual_totes.columns.tote_residual_quantity'),
      dataIndex: 'tote_residual_quantity',
      key: 'tote_residual_quantity',
      render: (v) => <Tag color="red">{v}</Tag>,
    },
    {
      title: t('shared.picking_lists.residual_totes.columns.tote_residual_items_count'),
      dataIndex: 'tote_residual_items_count',
      key: 'tote_residual_items_count',
    },
    {
      title: t('shared.picking_lists.residual_totes.columns.actions'),
      key: 'actions',
      render: (_, record) => (
        <Link to={`/picking_lists/${record.id}`}>
          <Button type="primary" size="small">
            {t('shared.picking_lists.residual_totes.actions.go_handle')}
          </Button>
        </Link>
      ),
    },
  ]

  return (
    <Card
      title={t('shared.picking_lists.residual_totes.title')}
      extra={
        <Button onClick={fetchData} loading={loading}>
          {t('common.button.refresh')}
        </Button>
      }
    >
      <div style={{ marginBottom: 16, color: '#888' }}>
        {t('shared.picking_lists.residual_totes.subtitle')}
      </div>
      {loading ? (
        <div style={{ textAlign: 'center', padding: 40 }}>
          <Spin />
        </div>
      ) : rows.length === 0 ? (
        <Empty description={t('shared.picking_lists.residual_totes.empty')} />
      ) : (
        <Table
          dataSource={rows}
          columns={columns}
          rowKey="id"
          pagination={{ pageSize: 50, showSizeChanger: true }}
        />
      )}
    </Card>
  )
}

export default ResidualTotes
